import { notification } from 'antd'
import { Constants } from './Constants'

// letters only (min 2) or IDN punycode: no registered TLD contains a bare digit ("hotmail.com40")
const isValidTld = (tld) => /^[a-z]{2,}$/i.test(tld) || /^xn--[a-z0-9-]+$/i.test(tld)

export const isValidEmail = (email) => {
    if (typeof email !== 'string') return false
    const formatOk =
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(
            email,
        )
    if (!formatOk) return false
    const domainParts = email.slice(email.lastIndexOf('@') + 1).split('.')
    return domainParts.length > 1 && isValidTld(domainParts[domainParts.length - 1])
}

export const isValidUrl = (url) => {
    return /^[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/.test(
        String(url),
    )
}

export const isValidFileType = (file) => {
    const isJpgOrPng = !file.type || file.type === 'image/jpeg' || file.type === 'image/png'
    if (!isJpgOrPng) {
        notification.error({ message: 'You can only upload JPG/PNG files!', key: 'isValidLogo.isJpgOrPng' })
        return false
    }
    return true
}
export const isValidFileSize = (file, sizeLimit) => {
    // Allow exactly sizeLimit bytes (organizers asked for "up to 5 MB").
    const isLtSizeLimit = !file.size || file.size <= sizeLimit
    if (!isLtSizeLimit) {
        notification.error({
            message: `Image must be smaller than ${sizeLimit / 1024 / 1024}MB!`,
            key: 'isValidLogo.isLtSizeLimit',
        })
        return false
    }
    return true
}

export const isValidLogo = (file) => {
    if (!isValidFileType(file)) {
        return false
    }

    if (!isValidFileSize(file, Constants.UPLOAD.LOGO_SIZE_LIMIT)) {
        return false
    }

    return true
}

export const isValidImage = (file) => {
    if (!isValidFileType(file)) {
        return false
    }

    if (!isValidFileSize(file, Constants.UPLOAD.FILE_SIZE_LIMIT)) {
        return false
    }

    return true
}

export const isValidUpload = (file, fileListProp) => {
    const isGtMaxUpload = fileListProp.length > Constants.UPLOAD.MAX_UPLOAD_AT_A_TIME
    if (isGtMaxUpload) {
        notification.error({
            message: `You can only upload up to ${Constants.UPLOAD.MAX_UPLOAD_AT_A_TIME} files at a time.`,
            key: 'isValidUpload.isGtMaxUpload',
        })
        return false
    }

    if (!isValidFileType(file)) {
        return false
    }

    if (!isValidFileSize(file, Constants.UPLOAD.ALBUM_FILE_SIZE_LIMIT)) {
        return false
    }

    return true
}

export const isValidUpload2 = (files) => {
    const isGtMaxUpload = files.length > Constants.UPLOAD.MAX_UPLOAD_AT_A_TIME
    if (isGtMaxUpload) {
        notification.error({
            message: `You can only upload up to ${Constants.UPLOAD.MAX_UPLOAD_AT_A_TIME} files at a time.`,
            key: 'isValidUpload.isGtMaxUpload',
        })
        return false
    }

    if (files.some((o) => !isValidFileType(o) || !isValidFileSize(o, Constants.UPLOAD.ALBUM_FILE_SIZE_LIMIT))) {
        return false
    }

    return true
}
